
export const getStyles = (_, { palette = {} }) => ({
  cardList: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: '1px',
    marginLeft: '1px',
  },
  visuallyHidden: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    padding: 0,
    border: 0,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap',
  },
  contents: {
    fontStyle: 'normal',
    fontSize: 12,
    lineHeight: '18px',
    position: 'relative',
    width: '100%',
  },
  cardHeader: {
    display: 'flex',
    flexFlow: 'column',
  },
  cardHeaderSmall: {
    height: '48px',
  },
  cardHeaderLarge: {
    height: '75px',
    fontSize: 14,
  },
  title: {
    fontWeight: 600,
    display: 'inline-block',
    margin: 'auto 0px',
  },
  titleIcon: {
    marginRight: '6px',
    fontSize: '20px !important',
    color: '#006DD1',
  },
  description: {
    fontWeight: 400,
  },
  footer: {
    fontWeight: 400,
    fontSize: '10px',
    color: palette.neutralSecondaryAlt,
    margin: '0px !important',
    bottom: 0,
    position: 'absolute',
  },
  selectableButtonLarge: {
    height: 167,
  },
  selectableButtonSmall: {
    height: 175,
  },
  selectableButton: {
    '&:hover, &:active': {
      outline: `1px solid ${palette.neutralPrimary}`,
      '& .shared-radio': {
        opacity: 1,
      },
    },
    '&.selected': {
      outline: `1px solid ${palette.themePrimary}`,
      '& .shared-radio': {
        opacity: 1,
      },
    },
    maxWidth: 335,
    display: 'inline-flex',
    float: 'left',
    backgroundColor: palette.white,
    marginRight: 20,
    marginBottom: 20,
    outline: `1px solid ${palette.white}`,
    border: 'none',
    boxShadow: '0px 1.6px 3.6px rgba(0, 0, 0, 0.132), 0px 0.3px 0px rgba(0, 0, 0, 0.108)',

    '& .selectable-card-label': {
      padding: '20px',
      height: '100%',
      cursor: 'pointer',
    },
    '&.is-disabled .selectable-card-label': {
      cursor: 'not-allowed',
    },

    '& .shared-radio': {
      float: 'right',
      top: '2px',
      right: '8px',
      position: 'relative',
      opacity: 0,
      '&:focus': {
        opacity: 1,
        outline: `1px solid ${palette.neutralPrimary}`,
      },
    },

    '& .icon-RadioBtnOff': {
      right: 5,
      zIndex: 1,
    },
  },
});
